import ApiRoutes from './ApiRoutes'
import HTTP from './HTTPService'

export default {
  getTimeslots() {
    return HTTP.get(ApiRoutes.timeslotsURL())
  }
}
